// @owners { team: patients }
import { COLORS, SIZES, SPACING } from '@alto/design-library-tokens';
import { Column, H1, Illustration, MdSpacing, Row } from '@alto/design-system';
import React, { useEffect, useRef } from 'react';
import { Animated, Platform } from 'react-native';
import styled from 'styled-components/native';
import checklist from '~shared/assets/images/checklist.png';
import { IMG_ALT_TEXTS } from '~shared/constants';

// On web, the parent containers don't use flex, so flexGrow alone doesn't fill the viewport.
// Force the background to span the visible content area (viewport minus the XxxlSpacing
// that apps/web's DashboardNavbar renders to offset the fixed navbar, minus the footer).
// We subtract XxxlSpacing (64px) rather than navbar height (68px) because XxxlSpacing is
// what actually occupies document flow above this page.
const Background = styled(Column)`
  ${Platform.OS === 'web'
    ? `min-height: calc(100vh - ${SPACING.STATIC.XXXL.px} - ${SIZES.PAGE.WEB_FOOTER_HEIGHT.LG});`
    : ''}
`;

export const CalculatingQuantities = () => {
  const translateY = useRef(new Animated.Value(-5)).current;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(translateY, {
          toValue: 5,
          duration: 750,
          useNativeDriver: true,
        }),
        Animated.timing(translateY, {
          toValue: -5,
          duration: 750,
          useNativeDriver: true,
        }),
      ]),
    ).start();
  }, [translateY]);

  return (
    <Background
      flexGrow={1}
      flexShrink={1}
      backgroundColor={COLORS.BACKGROUND_COLORS.PINK_LIGHT}
    >
      <Row
        center
        flexGrow={1}
      >
        <Column center>
          <Animated.View style={{ transform: [{ translateY }] }}>
            <Illustration
              size="lg"
              source={checklist}
              accessibilityLabel={IMG_ALT_TEXTS.checklist}
            />
          </Animated.View>
          <MdSpacing />
          <H1 center>Thanks! Now calculating your order...</H1>
        </Column>
      </Row>
    </Background>
  );
};
